<h2 mat-dialog-title>Acerca de job 2 job</h2>
<mat-dialog-content class="mat-typography">
    <h3>Compara vacantes al realizar un monto anualizado de ingresos y beneficios</h3>
    <h3>Descargo de responsabilidad</h3>
    <p>Al utilizar job 2 job considera que este es un texto informativo que contiene sugerencias, job 2 job no se hace responsable por los resultados obtenidos al utilizar los productos/servicios aquí mencionados. Asimismo, job 2 job no se hará responsable de discrepancias entre el monto obtenido y cualquier otro que pongan a la vista del usuario.</p>
    <h3>Tipo de contratación 100% nómina</h3>
    <p>Se utilizan los montos de la tabla de ISR mensual, anual y el valor de UMA del 2026.</p>
    <h3>Tipo de contratación Contractor</h3>
    <p>Como usuario debe considerar su propio cálculo de impuestos.</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cerrar</button>
</mat-dialog-actions>
